import { render, staticRenderFns } from "./CandidateLayout.vue?vue&type=template&id=9c805d32&scoped=true&"
import script from "./candidateLayout.js?vue&type=script&lang=js&"
export * from "./candidateLayout.js?vue&type=script&lang=js&"
import style0 from "./CandidateLayout.vue?vue&type=style&index=0&id=9c805d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c805d32",
  null
  
)

export default component.exports